import m from "mithril";
import {CardieWidget, defineWidget, InputWidget, ButtonNew, NoticeWidget, Notification} from "@nebularstreams/libmui";
import {ValidateStreamName} from "./StreamCard"
import Config from "../../../config/Config"

const

	// widget: Video Player
	NanoPlayer = defineWidget(
		({attrs, children}) => m(CardieWidget, {
			title: attrs.title || "Live Stream Player",
			collapsed: true,
			element: "div",
			expandedView: () => [
				...children,
				...attrs.state.streamname
					? [
						m("iframe", {
							src: `/nanoplay/nano-play.html?streamname=${attrs.state.streamname}&bintu=${Config.bintu || ""}&jwtoken=${attrs.state.token || ""}`
						})
					]
					: []
			]
		})
	),
	AddStreamName = (attrs, streamname) => {
		const {state} = attrs;
		state.streamname = streamname;
		m.redraw();
	},
	// widget: Video Player
	CustomNanoPlayer = defineWidget(
		({attrs, state, children}) => m(CardieWidget, {
			title: attrs.title || "Live Stream Player",
			element: "div",
			class: "livestreams",
			expandedView: () => [

				...attrs.state.liveStreams && attrs.liveStreamItem
					? [m("ul.flexcol.livestreamlist.w-100", attrs.state.liveStreams.map((item) => m(attrs.liveStreamItem, {
						item,
						onClick: (v) => {
							attrs.state.streamname = v;
							m.redraw();
						}
					})))]
					: [],
				...attrs.fixed ? [] : [

					m(".flexcol.w-100", [
						m(InputWidget, {
							label: attrs.textTitle || "Add a Livestream source",
							value: attrs.state.streamname,
							hint: attrs.orga ? attrs.orga + "-xxxxx" : "Enter a streamname",
							maxlength: 11,
							class: state.isValid ? "valid" : "invalid",
							oninput: (value) => {
								state.isValid = ValidateStreamName(attrs.orga, value);
								m.redraw();
							},
							onchange: (streamname) => AddStreamName(attrs, streamname)
						}),
						...attrs.help && !attrs.state.streamname
							? [
								m(NoticeWidget, {
									icon: "info-circle",
									text: attrs.help,
									class: "help noselect font-75"
								})
							] : []
					]),
				],
				...attrs.state.streamname
					? [
						m("iframe", {
							src: `/nanoplay/nano-play.html?streamname=${attrs.state.streamname}&bintu=${Config.bintu || ""}&jwtoken=${attrs.state.token || ""}`
						}),

						...children.length
							? children
							: (attrs.state.liveStreams?.findIndex((item) => item.key === attrs.state.streamname) >= 0)
								? [
									m(NoticeWidget, {
										icon: "info-circle",
										text: attrs.helpExisting,
										class: "help noselect font-75"
									})
								]
								: [
									m(ButtonNew, {
										class: "w-100 accentbutton unitheightsmall",
										icon: "broadcast-tower",
										text: "Save Live Stream Source",
										onClick: () => {

											if (!attrs.state.liveStreams) {
												attrs.state.liveStreams = [];
											}

											if (attrs.state.liveStreams.findIndex((item) => item.key === attrs.state.streamname) !== -1) {
												Notification.add("Already have that livestream");
												return;
											}
											;

											attrs.state.liveStreams.push({
												type: "videoItem",
												key: attrs.state.streamname,
												url: `${Config.bintuLivestreamPlay}/${attrs.state.streamname}`,
												size: 0,
												date: new Date(Date.now()).toUTCString()
											});
											delete attrs.state.streamname;
											m.redraw();
										}
									})
								]
					]
					: []
			]
		})
	);

export {NanoPlayer, CustomNanoPlayer};
